import { render, staticRenderFns } from "./CustomerCardHorizontal.vue?vue&type=template&id=0a7dfed7&scoped=true"
import script from "./CustomerCardHorizontal.vue?vue&type=script&lang=js"
export * from "./CustomerCardHorizontal.vue?vue&type=script&lang=js"
import style0 from "./CustomerCardHorizontal.vue?vue&type=style&index=0&id=0a7dfed7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7dfed7",
  null
  
)

export default component.exports